/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Enrich_Phase2_WriteInputs */

const en_directory_submit_enrich_phase2_write = /** @type {(inputs: Directory_Submit_Enrich_Phase2_WriteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Writing the listing`)
};

const zh_directory_submit_enrich_phase2_write = /** @type {(inputs: Directory_Submit_Enrich_Phase2_WriteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`撰写收录内容`)
};

/**
* | output |
* | --- |
* | "Writing the listing" |
*
* @param {Directory_Submit_Enrich_Phase2_WriteInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_enrich_phase2_write = /** @type {((inputs?: Directory_Submit_Enrich_Phase2_WriteInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Enrich_Phase2_WriteInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_enrich_phase2_write(inputs)
	return zh_directory_submit_enrich_phase2_write(inputs)
});
export { directory_submit_enrich_phase2_write as "directory.submit.enrich.phase2.write" }